/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Approval_TitleInputs */



/**
* | output |
* | --- |
* | "Approval" |
*
* @param {Event_Approval_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_approval_title = /** @type {((inputs?: Event_Approval_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Approval_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("赞同")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovação")
	return /** @type {LocalizedString} */ ("Approval")
});